// Array.flat支持，将来请使用vue-cli 4.0构建脚手架使用core-js 3.0解决此问题
if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, "flat", {
    value: function(depth) {
      let res = [],
        depthArg = depth || 1,
        depthNum = 0,
        flatMap = arr => {
          arr.map((element, index, array) => {
            if (
              Object.prototype.toString.call(element).slice(8, -1) === "Array"
            ) {
              if (depthNum < depthArg) {
                depthNum++;
                flatMap(element);
              } else {
                res.push(element);
              }
            } else {
              res.push(element);
              if (index === array.length - 1) depthNum = 0;
            }
          });
        };
      flatMap(this);
      return res;
    }
  });
}

// 公共函数
Date.prototype.Format = function(formatStr) {
    var str = formatStr;
    var Week = ["日", "一", "二", "三", "四", "五", "六"];
  
    str = str.replace(/yyyy|YYYY/, this.getFullYear());
    str = str.replace(
      /yy|YY/,
      this.getYear() % 100 > 9
        ? (this.getYear() % 100).toString()
        : "0" + (this.getYear() % 100)
    );
  
    str = str.replace(
      /MM/,
      this.getMonth() > 9 ? this.getMonth().toString() : "0" + this.getMonth()
    );
    str = str.replace(/M/g, this.getMonth());
  
    str = str.replace(/w|W/g, Week[this.getDay()]);
  
    str = str.replace(
      /dd|DD/,
      this.getDate() > 9 ? this.getDate().toString() : "0" + this.getDate()
    );
    str = str.replace(/d|D/g, this.getDate());
  
    str = str.replace(
      /hh|HH/,
      this.getHours() > 9 ? this.getHours().toString() : "0" + this.getHours()
    );
    str = str.replace(/h|H/g, this.getHours());
    str = str.replace(
      /mm/,
      this.getMinutes() > 9
        ? this.getMinutes().toString()
        : "0" + this.getMinutes()
    );
    str = str.replace(/m/g, this.getMinutes());
  
    str = str.replace(
      /ss|SS/,
      this.getSeconds() > 9
        ? this.getSeconds().toString()
        : "0" + this.getSeconds()
    );
    str = str.replace(/s|S/g, this.getSeconds());
  
    return str;
  };

//   if (window.HTMLElement) {
//     if (Object.getOwnPropertyNames(HTMLElement.prototype).indexOf('dataset') === -1) {
//       Object.defineProperty(HTMLElement.prototype, 'dataset', {
//         get: function () {
//           var attributes = this.attributes // 获取节点的所有属性
//           var name = []
//           var value = [] // 定义两个数组保存属性名和属性值
//           var obj = {} // 定义一个空对象
//           for (var i = 0; i < attributes.length; i++) { // 遍历节点的所有属性
//             if (attributes[i].nodeName.slice(0, 5) === 'data-') { // 如果属性名的前面5个字符符合"data-"
//               // 取出属性名的"data-"的后面的字符串放入name数组中
//               name.push(attributes[i].nodeName.slice(5));
//               // 取出对应的属性值放入value数组中
//               value.push(attributes[i].nodeValue);
//             }
//           }
//           for (var j = 0; j < name.length; j++) { // 遍历name和value数组
//             obj[name[j]] = value[j]; // 将属性名和属性值保存到obj中
//           }
//           return obj // 返回对象
//         }
//       })
//     }
//   }
